export function isStaffHasPermission(roles, types, actions) {
  if (isAdmin(roles)) return true;
  if (isManager(roles)) return true;
  if (isEditor(roles) && (!actions || actions.includes('edit'))) return true;
  if (isSeller(roles)) {
    // Seller only has permission for company profile, about, partner, cloud
    const allowedTypes = ['profile', 'about', 'partner', 'cloud'];
    if (types.some((t) => allowedTypes.includes(t))) return true;
  }
  return false;
}

export function isStaff(roles) {
  return isRole(roles, ['admin', 'manager', 'editor', 'seller']);
}

export function isPartner(roles) {
  return isRole(roles, ['partner', 'companyuser']);
}

export function isJudge(roles) {
  return isRole(roles, ['judge']);
}

export function isAdmin(roles) {
  return isRole(roles, ['admin']);
}

export function isManager(roles) {
  return isRole(roles, ['manager']);
}

export function isEditor(roles) {
  return isRole(roles, ['editor']);
}

export function isSeller(roles) {
  return isRole(roles, ['seller']);
}

export function isReader(roles) {
  return isRole(roles, ['reader', 'companyuser']);
}

export function isMangerAndPartner(roles) {
  return isRole(roles, ['admin', 'manager', 'partner']);
}

function isRole(roles, roleTiles) {
  if (!roles || roles.length < 1) return false;
  return !!roles.find((role) => roleTiles.includes(role.title));
}

export function isNotRole(roles, roleTiles) {
  if (!roles || roles.length < 1) {
    return false;
  }
  return !!roles.find((role) => role.title && !roleTiles.includes(role.title));
}
